module.exports = __webpack_public_path__ + "static/media/akp-flyer-final.b0ab1e90.jpg";